module.exports = __webpack_public_path__ + "img/cq_timeline_11-6b6c7f.png";